import { render, staticRenderFns } from "./manageDetail.vue?vue&type=template&id=37708d78&scoped=true"
import script from "./manageDetail.vue?vue&type=script&lang=js"
export * from "./manageDetail.vue?vue&type=script&lang=js"
import style0 from "./mixins/detailLayout.scss?vue&type=style&index=0&id=37708d78&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37708d78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37708d78')) {
      api.createRecord('37708d78', component.options)
    } else {
      api.reload('37708d78', component.options)
    }
    module.hot.accept("./manageDetail.vue?vue&type=template&id=37708d78&scoped=true", function () {
      api.rerender('37708d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/approvalList/manageDetail.vue"
export default component.exports